module.exports = __webpack_public_path__ + "img/reports.e257455a.png";